window.onload = function() {  
  const SCREEN_WIDTH_TABLET = 767

  function handleLessMoreDescription() {
    const elmDescription = document.querySelector('.product__description-value')
    const elmReadMore = document.querySelector('.btn-readmore')
    const elmReadLess = document.querySelector('.btn-readless')
    // if (elmDescription) {
    //   const scrollHeight = elmDescription.offsetHeight
    //   if (scrollHeight > 90) {
    //     elmDescription.style.height = '83px'
    //     elmReadMore.classList.remove('hidden')
    //   }
    // }

    const textContainer = document.querySelector('.product__description');
    const text = textContainer.querySelector('.product__description-value');
    // const showMoreBtn = textContainer.querySelector('.btn-readmore');

    const fullHeight = text.scrollHeight;

    if (text.clientHeight < fullHeight) {
      elmReadMore.classList.remove('hidden')
    }

    if (elmReadMore) {
      elmReadMore.addEventListener('click', function () {
        // elmDescription.style.height = 'auto'
  
        elmReadMore.classList.add('hidden')
        elmReadLess.classList.remove('hidden')
        text.classList.remove('has__line-clamp');
      })
    }

    if (elmReadLess) {
      elmReadLess.addEventListener('click', function () {
        // elmDescription.style.height = '83px'
  
        elmReadLess.classList.add('hidden')
        elmReadMore.classList.remove('hidden')
        text.classList.add('has__line-clamp');
      })
    }
  }
  handleLessMoreDescription()

  function handleStyleProductInfor() {
    const sectionProductInfor = document.querySelector('.product')
    if(window.screen.width > SCREEN_WIDTH_TABLET) {
      const HEIGHT_APP_SCALAPAY = 56
      const heightOfProductInfor = document.querySelector('.product__info-wrapper').offsetHeight 
      const heightOfMedia = document.querySelector('.product__media-wrapper').offsetHeight

      if(heightOfProductInfor > heightOfMedia) {
        sectionProductInfor.style.height = Math.round(heightOfProductInfor) + HEIGHT_APP_SCALAPAY + 'px'
      }

      if(heightOfMedia > heightOfProductInfor) {
        sectionProductInfor.style.height = Math.round(heightOfMedia) + HEIGHT_APP_SCALAPAY + 'px'
      }
    } else {
      sectionProductInfor.style.height = 'auto'
    }
  }
  handleStyleProductInfor()

  const observer = new MutationObserver(() => {
    handleStyleProductInfor()
  })
  
  observer.observe(document.querySelector('product-info'), {
    subtree: true,
    childList: true,
  })

  function handleAddToCartSticky() {
    const btnSubmit = document.querySelector('.btn-sticky-add-to-cart')
    if (btnSubmit) {
      btnSubmit.addEventListener('click', async function() {


        document.querySelector('.product-form.rocket-buy-buttons .product-form__submit').click()

        // const dataJSON = JSON.parse(document.querySelector('.section-product-sticky-bar variant-selects script[type="application/json"]').textContent)
        // let variantValue
        // if(document.querySelector('variant-radios .box-options input[type="radio"]:checked')) {
        //   variantValue = document.querySelector('variant-radios .box-options input[type="radio"]:checked').value
        // } else {
        //   variantValue = document.querySelector('.section-product-sticky-bar .select select').value
        // }
        // document.querySelector(".rocket-buy-buttons .product-form__submit").click();
        // const variant = findVariantId(variantValue, null, dataJSON)
        // const data = {
        //   items: [
        //     {
        //       id: variant.id,
        //       quantity: 1,
        //     },
        //   ],
        // }
    
        // await fetch(window.Shopify.routes.root + 'cart/add.js', {
        //   method: 'POST',
        //   headers: {
        //     'Content-Type': 'application/json'
        //   },
        //   body: JSON.stringify(data),
        // })
        //   .then(response => {
        //     // window.location = window.routes.cart_url;
        //     // document.querySelector(".rocket-buy-buttons .product-form__submit").click();

        //     // setTimeout(() => {
        //     //   document.querySelector("#cart-icon-bubble").click();
        //     // },1000);

            
        //     // openMiniCart()
    
        //     // if template is collection
        //     // if (document.body.classList.contains('template-collection')) {
        //     //   button.closest('.quickbuy-toggle__mobile').classList.add('hidden')
        //     //   button.closest('.block-inner').querySelector('.quick-buy__icon').classList.remove('hidden')
        //     // }
        //   })
        //   .catch((error) => {
        //     console.error('Error:', error)
        //     alert('Error adding product to cart')
        //   })
      })
    }
  }

  handleAddToCartSticky()

  function findVariantId(option1, option2, dataJSON) {
    if(option1) {
      return dataJSON.variants.find(item => {
        if(item.available && item.option1 === option1) return item.id
      })
    }
  }

  function toggleChooseSize() {
    const btnOpenSize = document.querySelector('.btn-show-size')
    if (btnOpenSize) {
      btnOpenSize.addEventListener('click', () => {
        document.getElementById('form-id-custom').scrollIntoView()
      })
    }
  }
  toggleChooseSize()

  function handleStickyBar() {
    const stickyBarPdp = document.querySelector(".section-product-sticky-bar")
    const mainProductTopHeight = document.querySelector('.product-form__submit').offsetTop
    if(stickyBarPdp) {
      window.addEventListener('scroll', function (e) {
        if (window.pageYOffset >= mainProductTopHeight) {
          stickyBarPdp.classList.add('is-sticky')
        } else {
          stickyBarPdp.classList.remove('is-sticky')
        }
      })
    }
  }
  // handleStickyBar()

  const elmSwiperProductMedia = document.querySelector('.section-product__media-list')
  if (elmSwiperProductMedia) {
    new Swiper(elmSwiperProductMedia.querySelector('.swiper'), {
      loop: false,
      spaceBetween: 0,
      slidesPerView: 'auto',
      navigation: {
        nextEl: elmSwiperProductMedia?.querySelector('.swiper-button-next'),
        prevEl: elmSwiperProductMedia?.querySelector('.swiper-button-prev'),
      },
      on: {
        init: function () {
          document.getElementById('current-slide').textContent = this.activeIndex + 1;
        },
        slideChange: function () {
          document.getElementById('current-slide').textContent = this.activeIndex + 1;
        }
      },
      mousewheel: {
        forceToAxis: true,
      }
    })
  }


  function isOutOfViewport(element) {
    const rect = element.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const windowWidth = window.innerWidth || document.documentElement.clientWidth;

    return (
        rect.bottom < 0 ||
        rect.top > windowHeight ||
        rect.right < 0 ||
        rect.left > windowWidth
    )
  }

  function toggleStickyBar() {
    const productButtons = document.querySelector('.product-form.rocket-buy-buttons')
    const stickyBar = document.querySelector('.section-product-sticky-bar')    

    if (!productButtons || !stickyBar) return;

    if (isOutOfViewport(productButtons)) {
      stickyBar.classList.add('is-sticky')
    } else {
      stickyBar.classList.remove('is-sticky')
    }
  }

  window.addEventListener('scroll', toggleStickyBar)
  toggleStickyBar()
}